import { toast } from "sonner";

import { CopyNotification } from "@/components/buttons/share-button";

export default function useShare(shareData: ShareData, fallbackToCopy = true) {
  const handleFallback = async (data: ShareData) => {
    if (!fallbackToCopy) {
      return;
    }

    await navigator.clipboard.writeText(
      data.url || data.title || data.text || ""
    );
    toast.custom((id) => (
      <CopyNotification onClose={() => toast.dismiss(id)} />
    ));
  };

  const share = (customShareData?: ShareData) => {
    const data = customShareData || shareData;

    try {
      if (navigator.canShare(data)) {
        navigator.share(data);
        return true;
      }
    } catch {
      /* Expected */
    }

    handleFallback(data);

    return false;
  };

  return {
    onShare: () => share(),
    share,
  };
}
